module.exports = __webpack_public_path__ + "static/media/am_view-past-submissions.9983c3c4.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_view-past-submissions.md
// module id = 1090
// module chunks = 0